<script lang="ts">
	import { ScrollArea as ScrollAreaPrimitive, type WithoutChild } from 'bits-ui';
	import { cn } from '@ui-lib/utils/utils.js';

	let {
		ref = $bindable(null),
		class: className,
		orientation = 'vertical',
		topOffset = 0,
		children,
		...restProps
	}: WithoutChild<ScrollAreaPrimitive.ScrollbarProps> & {
		topOffset?: number;
	} = $props();

	const scrollbarStyle = $derived(
		topOffset > 0 && orientation === 'vertical'
			? `margin-top: ${topOffset}px; height: calc(100% - ${topOffset}px);`
			: undefined
	);
</script>

<ScrollAreaPrimitive.Scrollbar
	bind:ref
	{orientation}
	class={cn(
		'flex touch-none select-none transition-colors',
		orientation === 'vertical' && 'h-full w-2.5 border-l border-l-transparent p-px',
		orientation === 'horizontal' && 'h-2.5 w-full border-t border-t-transparent p-px',
		className
	)}
	style={scrollbarStyle}
	{...restProps}
>
	{@render children?.()}
	<ScrollAreaPrimitive.Thumb
		class={cn('bg-border relative rounded-full', orientation === 'vertical' && 'flex-1')}
	/>
</ScrollAreaPrimitive.Scrollbar>
